import React, { useEffect, useMemo } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { addBrand, getManufacturers } from "../../../redux/CarsManagement/Brands/brandsSlice";
import StatusSelect from "../../../components/CustomSelect/StatusSelect";
import MaintenanceSelect from "../../../components/CustomSelect/MaintenanceSelect";
import CustomInput from "../../../components/CustomInput/CustomInput";
import { NavLink } from "react-router-dom";
import Select from "react-select";

function BrandsActions() {
  const dispatch = useDispatch();
  const { addBrandModalValues, manufacturers } = useSelector(
    (state) => state.brands
  );

  const {
    formState: { errors, isValid },
    handleSubmit,
    reset,
    control,
    setValue,
  } = useForm({
    defaultValues: addBrandModalValues,
  });

  useEffect(() => {
    dispatch(getManufacturers());
  }, [dispatch]);

  const manufacturerOptions = useMemo(() => {
    return (manufacturers || []).map((m) => ({
      value: m.manufacturerName1,
      label: `${m.manufacturerName1} - ${m.manufacturerName2}`,
      nameEn: m.manufacturerName1,
      nameAr: m.manufacturerName2,
    }));
  }, [manufacturers]);

  const resetAddBrandModalValues = () => {
    reset(addBrandModalValues);
  };

  const handleAddBrand = (data) => {
    dispatch(
      addBrand({
        nameAr: data.nameAr,
        nameEn: data.nameEn,
        order: data.order,
        status: data.status,
        viewinmaintenance: data.viewinmaintenance,
      })
    );

    resetAddBrandModalValues();
  };

  return (
    <>
      <nav className="uk-position-relative" aria-label="Breadcrumb">
        <ul className="uk-breadcrumb">
          <li>
            <NavLink to="/Cars">السيارات</NavLink>
          </li>
          <li>
            <span aria-current="page">المُصنع</span>
          </li>
        </ul>

        <button
          className="uk-button uk-button-primary uk-button-small uk-border-rounded uk-position-left"
          uk-toggle="target: #addBrandModal"
        >
          <span className="uk-margin-small-left" uk-icon="plus"></span>
          إنشاء
        </button>
      </nav>

      <div id="ModalOfBrand">
        <div
          id="addBrandModal"
          uk-modal="bg-close: false"
          container="#ModalOfBrand"
        >
          <div className="uk-modal-dialog">
            <button
              className="uk-modal-close-default"
              type="button"
              uk-close=""
              onClick={resetAddBrandModalValues}
            ></button>

            <div className="uk-modal-header uk-text-center">
              <h2 className="uk-modal-title">إضافة مُصنع</h2>
            </div>

            <div className="uk-modal-body">
              <form className="uk-grid-small uk-child-width-1-2" uk-grid="">
                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                    المصنع
                  </label>
                  <div className="uk-form-controls uk-margin-small-top">
                    <Controller
                      name="manufacturer"
                      control={control}
                      rules={{ required: "هذا الحقل مطلوب!" }}
                      render={({ field }) => (
                        <Select
                          options={manufacturerOptions}
                          isSearchable
                          placeholder="ابحث عن المصنع"
                          value={
                            manufacturerOptions.find(
                              (x) => x.value === field.value
                            ) || null
                          }
                          onChange={(selected) => {
                            field.onChange(selected.value);
                            setValue("nameAr", selected.nameAr);
                            setValue("nameEn", selected.nameEn);
                          }}
                        />
                      )}
                    />
                  </div>
                </div>

                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                    الإسم بالعربي
                  </label>
                  <div className="uk-form-controls uk-margin-small-top">
                    <CustomInput
                      control={control}
                      name="nameAr"
                      error={errors.nameAr}
                    />
                  </div>
                </div>

                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                    الإسم بالإنجليزي
                  </label>
                  <div className="uk-form-controls uk-margin-small-top">
                    <CustomInput
                      control={control}
                      name="nameEn"
                      error={errors.nameEn}
                    />
                  </div>
                </div>

                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                    الترتيب
                  </label>
                  <div className="uk-form-controls uk-margin-small-top">
                    <CustomInput
                      control={control}
                      name="order"
                      error={errors.order}
                      type="number"
                    />
                  </div>
                </div>

                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                    الحالة
                  </label>
                  <div className="uk-form-controls uk-margin-small-top">
                    <Controller
                      name="status"
                      control={control}
                      rules={{
                        validate: (v) =>
                          typeof v === "boolean" || "هذا الحقل مطلوب!",
                      }}
                      render={({ field }) => (
                        <StatusSelect field={field} error={errors.status} />
                      )}
                    />
                  </div>
                </div>

                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                    عرض في الصيانة
                  </label>
                  <div className="uk-form-controls uk-margin-small-top">
                    <Controller
                      name="viewinmaintenance"
                      control={control}
                      rules={{
                        validate: (v) =>
                          typeof v === "boolean" || "هذا الحقل مطلوب!",
                      }}
                      render={({ field }) => (
                        <MaintenanceSelect
                          field={field}
                          error={errors.viewinmaintenance}
                        />
                      )}
                    />
                  </div>
                </div>
              </form>
            </div>

            <div className="uk-modal-footer uk-text-left">
              <button
                className={`uk-button uk-button-secondary uk-margin-small-left uk-border-rounded${
                  isValid ? " uk-modal-close" : ""
                }`}
                type="button"
                onClick={handleSubmit(handleAddBrand)}
              >
                إضافه
              </button>

              <button
                className="uk-button uk-button-primary uk-modal-close uk-border-rounded"
                type="button"
                onClick={resetAddBrandModalValues}
              >
                إلغاء
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BrandsActions;